import { Stack, StackProps } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { Link as RouterLink, To } from 'react-router';

interface Props extends StackProps {
  to: To;
}

export const Link: React.FC<PropsWithChildren<Props>> = ({ to, children }) => (
  <Stack
    component={RouterLink}
    to={to}
    direction="row"
    sx={{
      alignItems: 'center',
      color: 'primary.main',
      textDecoration: 'none',
      flexWrap: 'nowrap',
      '&:hover': { textDecoration: 'underline' },
    }}
  >
    {children}
  </Stack>
);
